import http, { HttpSuccessOrErrorType } from '../http';
import { FirstMenu, FirstMenuString, ResultSetHeader } from '../../models';
export default {
    /**
     * 创建单个first_menu资源。
     * @param params 参数
     */
    async post_restaurant_string_id_first_menu(params: FirstMenu & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params
        return await http.post(`/restaurant/${string_id}/first_menu`, {
            ...rest
        })
    },

    /**
     * 根据 first_menus创建或者修改多个first_menu_string资源。
     * @param params 参数
     */
    async post_restaurant_string_id_first_menu_first_menu_strings(params: { string_id: string, ruleSetInfo: Array<FirstMenuString> }): Promise<HttpSuccessOrErrorType<FirstMenuString[]>> {
        const { string_id, ruleSetInfo } = params;
        return await http.post(`/restaurant/${string_id}/first_menu/first_menu_strings`, ruleSetInfo)
    },

    /**
     * 查询 所有 first_menu 资源
     * @param string_id 参数
     */
    async get_restaurant_string_id_first_menus(string_id: string): Promise<HttpSuccessOrErrorType<FirstMenu[]>> {
        return await http.get(`/restaurant/${string_id}/first_menus`)
    },

    /**
     * 根据 first_menu.main_group_id 查询 单个 first_menu 资源
     * @param params 参数
     */
    async get_restaurant_string_id_first_menu_id(params: { string_id: string, id: string }): Promise<HttpSuccessOrErrorType<FirstMenu[]>> {
        const { string_id, id } = params;
        return await http.get(`/restaurant/${string_id}/first_menu/${id}`)
    },

    /**
     * 一级菜单详情
     * @param string_id 参数
     */
    async get_restaurant_string_id_first_menu_condition(params: { string_id: string, name: string, pagination_per_page: number }): Promise<HttpSuccessOrErrorType<FirstMenu[]>> {
        const { string_id, ...rest } = params;
        return await http.get(`/restaurant/${string_id}/first_menu/condition`, {
            params: {
                ...rest
            }
        })
    },

    /**
     * 修改
     * @param params 参数
     */
    async patch_restaurant_string_id_first_menu_id(params: { string_id: string } & Omit<FirstMenu, 'secondMenus' | 'firstMenuStrings'>): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, main_group_id, ...rest } = params;
        return await http.patch(`/restaurant/${string_id}/first_menu/${main_group_id}`, {
            ...rest
        })
    },

    /**
     * 删除单个一级菜单
     * @param params 参数
     */
    async delete_restaurant_string_id_first_menu_id(params: { string_id: string, id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, id } = params;

        return await http.delete(`/restaurant/${string_id}/first_menu/${id} `, {
        })
    },

    /**
     * 删除整个餐厅的一级菜单
     * @param string_id 参数
     */
    async delete_restaurant_string_id_first_menus(params: { string_id: string, ids: number[] }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ids } = params;
        return await http.delete(`/restaurant/${string_id}/first_menus`, {
            data: {
                ids
            }
        })
    },

    /**
     * 根据 first_menu.main_group_id 和 ids 删除 first_menu_string 的多个资源
     * @param string_id 参数
     */
    async delete_restaurant_string_id_first_menu_first_menu_strings(string_id: string): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        return await http.delete(`/restaurant/${string_id}/first_menu/first_menu_strings`, {
        })
    }
}